import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Mi ha letteralmente cambiato la vita. Facevo 12 lezioni a settimana e non riuscivo più a pianificare. Ora apro il volume, leggo 5 minuti e ho una lezione bellissima già pronta.',
    initials: 'GR',
    name: 'Giulia R.',
    location: 'Milano, Lombardia 🇮🇹'
  }, {
    quote: 'Quello che amo di più sono i temi e le intuizioni. Faticavo a integrarli senza sembrare forzata. Ora le mie allieve mi dicono che le lezioni hanno molta più profondità.',
    initials: 'FB',
    name: 'Francesca B.',
    location: 'Roma, Lazio 🇮🇹'
  }, {
    quote: 'Il modulo di Yoga Terapeutico vale oro. Ero insicura quando arrivavano allieve con mal di schiena, ora ho protocolli chiari per prendermi cura di loro.',
    initials: 'CM',
    name: 'Chiara M.',
    location: 'Torino, Piemonte 🇮🇹'
  }, {
    quote: 'A € 19 è un regalo. Solo il registro allievi e le schede rapide mi hanno già fatto risparmiare ore di lavoro. Consigliatissimo a chi inizia da poco.',
    initials: 'SL',
    name: 'Sara L.',
    location: 'Bologna, Emilia-Romagna 🇮🇹'
  }, {
    quote: 'Le sequenze sono fluide e logiche. Le mie allieve hanno notato subito la differenza, le lezioni sembrano molto più professionali e curate.',
    initials: 'VC',
    name: 'Valentina C.',
    location: 'Firenze, Toscana 🇮🇹'
  }, {
    quote: 'Adoro che sia pensato per chi insegna davvero. Arrivo in aula serena, con tutto pronto, e la domenica finalmente riposo. Grazie di cuore!',
    initials: 'AM',
    name: 'Alessia M.',
    location: 'Napoli, Campania 🇮🇹'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-155">
      <div className="max-w-6xl mx-auto" data-id="element-156">
        <div className="text-center mb-16" data-id="element-157">
          <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-4" data-id="element-158">
            Cosa dicono le Insegnanti Italiane.
          </h2>
          <div className="flex items-center justify-center gap-2 text-brand-gray font-medium" data-id="element-159">
            <div className="flex gap-0.5" data-id="element-160">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-161" />)}
            </div>
            <span data-id="element-162">4.9/5 &middot; 380+ Recensioni</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-163">
          {testimonials.map((t, i) => <div key={i} className="bg-[#f9f5ef] rounded-3xl p-8 flex flex-col h-full border border-brand-creamDark/50" data-id="element-164">
              <div className="flex gap-0.5 mb-6" data-id="element-165">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-166" />)}
              </div>
              <p className="text-brand-text font-medium mb-8 flex-1 leading-relaxed" data-id="element-167">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-168">
                <div className="w-10 h-10 rounded-full bg-brand-green text-white flex items-center justify-center font-bold text-sm shrink-0" data-id="element-169">
                  {t.initials}
                </div>
                <div data-id="element-170">
                  <p className="font-bold text-brand-text text-sm" data-id="element-171">{t.name}</p>
                  <p className="text-xs text-brand-gray" data-id="element-172">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}